/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE = '/payment';
const RESOURCE_PAGE_GIFT_ROUTE_CARTSERVICE = '/giftcard';

/**
 * removeGiftCard
 * url - /checkout/{apiVersion}/cart/payment/{cartId}/giftcard?giftCardId={giftCardId}&brand={brandId}
 *
 * @param {Object} args
 * @param {Object} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 */
const removeGiftCard = ({
    env, jwtToken, cartId, giftCardId,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const payload  = {
        giftCardId,
    };
    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}${RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_GIFT_ROUTE_CARTSERVICE}`;

    return restClient.deleteRequest(envObj, resourcePage, jwtToken, null, payload)
        .then((response) => response);
};

export default removeGiftCard;
